import {
  type PageEntity,
  apiClient,
  type AdditionalPaymentCategoryEntity
} from '@/libs/api'
import type { ReportType } from '@/libs/api/types'

export type FetchAdditionalPaymentCategoriesQuery = {
  tenantKey: string
  reportType: ReportType
}

export type FetchAdditionalPaymentCategoriesResponse = {
  data: AdditionalPaymentCategoryEntity[]
  pagination: PageEntity | null
}

// 追加支払運賃項目SELECT用 一覧取得API
export const fetchAdditionalPaymentCategories = async (
  { tenantKey, reportType }: FetchAdditionalPaymentCategoriesQuery,
  signal?: AbortSignal
): Promise<FetchAdditionalPaymentCategoriesResponse> => {
  const { data, pagination } = await apiClient
    ._tenant(tenantKey)
    .additional_payment_categories.$get({
      // page: -1 を指定することでページネーションを無効にする
      // isActive: true を指定することで利用可能な項目のみ取得できるようにする
      query: {
        page: -1,
        isActive: true,
        reportType
      },
      config: {
        signal
      }
    })
  return {
    data,
    pagination
  }
}
